import type { AppEnvType } from '../app-env';
import { getAppEnv } from '../app-env';

import type { IAiEnv } from './ai';
import { getAiEnv } from './ai';
import type { IBetterAuthEnv } from './better-auth';
import { getBetterAuthEnv } from './better-auth';
import type { IBillingEnv } from './billing';
import { getBillingEnv } from './billing';
import type { IElevenLabsEnv } from './elevenlabs';
import { getElevenLabsEnv } from './elevenlabs';
import type { IEmailResendEnv } from './email-resend';
import { getEmailResendEnv } from './email-resend';
import type { IGa4Env } from './ga4';
import { getGa4Env } from './ga4';
import { getNodeEnv } from './get-node-env';
import type { IS3Env } from './s3';
import { getS3Env } from './s3';
import type { ISentryEnv } from './sentry';
import { getSentryEnv } from './sentry';
import type { ISlackEnv } from './slack';
import { getSlackEnv } from './slack';
import type { ISocialEnv } from './social';
import { getSocialEnv } from './social';
import type { ITelegramEnv } from './telegram';
import { getTelegramEnv } from './telegram';
import type { ITurnstileEnv } from './turnstile';
import { getTurnstileEnv } from './turnstile';

export interface IEnvConfig {
  ai: () => IAiEnv;
  appEnv: () => AppEnvType;
  billing: () => IBillingEnv;
  betterAuth: () => IBetterAuthEnv;
  elevenLabs: () => IElevenLabsEnv;
  emailResend: () => IEmailResendEnv;
  ga4: () => IGa4Env;
  nodeEnv: () => string;
  s3: () => IS3Env;
  sentry: () => ISentryEnv;
  slack: () => ISlackEnv;
  social: () => ISocialEnv;
  telegram: () => ITelegramEnv;
  turnstile: () => ITurnstileEnv;
}

export const env: IEnvConfig = {
  ai: getAiEnv,
  appEnv: getAppEnv,
  betterAuth: getBetterAuthEnv,
  billing: getBillingEnv,
  elevenLabs: getElevenLabsEnv,
  emailResend: getEmailResendEnv,
  ga4: getGa4Env,
  nodeEnv: getNodeEnv,
  s3: getS3Env,
  sentry: getSentryEnv,
  slack: getSlackEnv,
  social: getSocialEnv,
  telegram: getTelegramEnv,
  turnstile: getTurnstileEnv,
};
